import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import HeroSection from './HeroSection';
import Tech from './tech';
import End from './End';




const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
  <App />
    <HeroSection />
    <Tech/>
    
    <End/>
  
    
  

  </>
  
        
 
);